export default __webpack_public_path__ + "static/media/okapp-logo.a77bd78e.png";